import http from 'plugins/axios';

export default {

    createTradeRange(data) {
        return http.post({
            url: '/admin/tradeSet/create',
            data,
            dataType: 'form'
        });
    },

    updateTradeRange(data) {
        return http.post({
            url: '/admin/tradeSet/update',
            data,
            dataType: 'form'
        });
    },

    listTradeRange(data) {
        return http.get({
            url: '/admin/tradeSet/list',
            data
        })
    },

    removeTradeSet(data) {
        return http.post({
            url: '/admin/tradeSet/remove',
            data,
            dataType: 'form'
        })
    },

    sortTradeSet(data) {
        return http.post({
            url: '/admin/tradeSet/sort',
            data,
            dataType: 'form'
        })
    }
}
